// 账号校验
export function names(rule, value, callback) {
  const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;;
  if (value == '' || value == undefined || value == null) {
    callback(new Error('账号不能为空'));
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的电话号码或者固话号码'));
    } else {
      callback();
    }
  }
}
export function phone(rule,value,callback) {
  const reg = /^1[34578]\d{9}$/
  if (value == '' || value == undefined || value == null) {
    callback(new Error('账号不能为空'));
  } else {
    if ((!reg.test(value)) && value != '') {
      callback(new Error('请输入正确的电话号码或者固话号码'));
    } else {
      callback();
    }
  }
}
// 密码校验
export function validatePsdReg(rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入密码'))
  }
  if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/.test(value)) {
    callback(new Error('请输入6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种'))
  } else {
    callback()
  }
}
// 身份证校验
export function ID(rule, value, callback) {
  if (!value) {
    return callback(new Error('身份证不能为空'))
  }
  if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
    callback(new Error('请输入正确的二代身份证号码'))
  } else {
    callback()
  }
}
//账号校验
export function validateCode(rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入账号'))
  }
  if (!/^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6,20}$/.test(value)) {
    callback(new Error('账号必须为6-20位字母和数字组合'))
  } else {
    callback()
  }
}
//不能为空
export function notNull(rule, value, callback) {
  const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;;
  if (value == '' || value == undefined || value == null) {
    callback(new Error('不能为空'));
  } else{
    callback();
  }
}
//纯数字校验
export function validateNumber(rule, value, callback) {
  let numberReg = /^\d+$|^\d+[.]?\d+$/
  if (value !== '') {
    if (!numberReg.test(value)) {
      callback(new Error('请输入数字'))
    } else {
      callback()
    }
  } else {
    callback(new Error('请输入值'))
  }
}
//去除一个数组中与另一个数组中的值相同的元素
export function array_diff(a, b) {
  for (var i = 0; i < b.length; i++) {
    for (var j = 0; j < a.length; j++) {
      if (a[j].name == b[i]) {
        a.splice(j, 1);
        j = j - 1;
      }
    }
  }
  return a;
}
export function getCaption(obj){

  var index=obj.lastIndexOf(".");
  obj=obj.substring(index+1,obj.length);
   console.log(obj);
  return obj;
  }
export function IsEmail(rule, value, callback) {
  let numberReg = /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/
  if (value !== '') {
    if (!numberReg.test(value)) {
      callback(new Error('请输入正确的邮箱格式'))
    } else {
      callback()
    }
  }else{
    callback()
  }
}
export default {
  names,
  validatePsdReg,
  ID,
  array_diff,
  notNull,
  IsEmail,
  getCaption,
  phone
}



// WEBPACK FOOTER //
// ./src/components/util/index.js